import { render, staticRenderFns } from "./SanityLoopvideoSerializer.vue?vue&type=template&id=758f56a5&scoped=true&"
import script from "./SanityLoopvideoSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityLoopvideoSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityLoopvideoSerializer.vue?vue&type=style&index=0&id=758f56a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758f56a5",
  null
  
)

export default component.exports